import { Component } from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

@Component({
    selector: 'app-data-share-code-dialog',
    standalone: true,
    imports: [MatDialogModule, MatButtonModule, MatFormFieldModule, MatInputModule, ReactiveFormsModule],
    template: `
        <h2 mat-dialog-title>6-stelliger Code</h2>
        <div mat-dialog-content>
            <mat-form-field appearance="outline" class="w-full">
                <mat-label>Code aus der Up2Boat App</mat-label>
                <input matInput [formControl]="codeControl" maxlength="6" />
            </mat-form-field>
        </div>
        <div mat-dialog-actions align="end">
            <button mat-button mat-dialog-close>Abbrechen</button>
            <button mat-flat-button color="primary" [disabled]="codeControl.invalid" (click)="submit()">
                Übernehmen
            </button>
        </div>
    `
})
export class AppDataShareCodeDialogComponent {
    readonly codeControl = new FormControl('', [Validators.required, Validators.minLength(6), Validators.maxLength(6)]);

    constructor(private readonly dialogRef: MatDialogRef<AppDataShareCodeDialogComponent>) {}

    submit(): void {
        if (this.codeControl.invalid) {
            return;
        }

        this.dialogRef.close(String(this.codeControl.value || '').toUpperCase());
    }
}
